import { render, staticRenderFns } from "./DownloadBox.vue?vue&type=template&id=68293ff5&scoped=true"
import script from "./DownloadBox.vue?vue&type=script&lang=js"
export * from "./DownloadBox.vue?vue&type=script&lang=js"
import style0 from "./DownloadBox.vue?vue&type=style&index=0&id=68293ff5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68293ff5",
  null
  
)

export default component.exports